import React, { useEffect, useState, FC } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { gql, useMutation, useQuery } from '@apollo/client';
import * as types from "../gql/graphql";

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Autocomplete from '@mui/material/Autocomplete';

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Card from "@mui/material/Card";

import MDBoxRoot from './MDBox/MDBoxRoot';
import MDButtonRoot from './MDButton/MDButtonRoot';
import MDInput from './MDInput/MDInputRoot';
import MDTypographyRoot from './MDTypography/MDTypographyRoot';
import { useScreenSize } from "../hooks/ScreenSizeContext";

import "primereact/resources/themes/md-light-indigo/theme.css";


// Get all instructors for the event
const getInstructorAssignmentQuery = gql(`
query GetInstructorAssignments($id: BigInt) {
    fs_instructoreventsCollection(filter: {event: {eq: $id}}) {
      edges {
        node {
          nodeId
          on_deck
          id
          instructor
          fs_admins {
            email
            first_name
            last_name
            id
          }
        }
      }
    }
  }
`);

// Add instructor to the event (optionally as "on deck")
const assignInstructorQuery = gql(`
mutation AssignInstructorToEvent($eventId: BigInt, $instrId: BigInt, $onDeck: Boolean) {
    insertIntofs_instructoreventsCollection(
      objects: [{event: $eventId, instructor: $instrId, on_deck: $onDeck}]
    ) {
      records {
        nodeId
        on_deck
        id
        instructor
        fs_admins {
          email
          first_name
          last_name
          id
        }
      }
    }
  }
`);

// Update instructor event assignment ("on deck")
const updateInstructorAssignmentQuery = gql(`
mutation UpdateInstructorForEvent($id: BigInt, $onDeck: Boolean) {
    updatefs_instructoreventsCollection(
      filter: {id: {eq: $id}}
      set: {on_deck: $onDeck}
    ) {
      records {
        nodeId
        on_deck
        id
        instructor
        fs_admins {
          email
          first_name
          last_name
          id
        }
      }
    }
  }
`);

// Remove instructor from event
const deleteInstructorAssignmentQuery = gql(`
mutation deleteInstructorAssignment($id:BigInt) {
    deleteFromfs_instructoreventsCollection(
      filter: {id: {eq: $id}}
    ) {
      affectedCount
    }
  }
`);

// TODO: Move into DB access library
const getAllInstructorsQuery = gql(`
  query GetAllInstructors {
    fs_adminsCollection {
        edges {
          node {
            nodeId
            id
            first_name
            last_name
            email
            super
            staff
            instructor
          }
        }
      }
  }
`);

/* const searchInstructorQuery = gql(`
query SearchInstructor($st: String, $cl: BigInt) {
    get_available_regs_for_event(p_class: $cl, p_search: $st) {
      edges {
        node {
          id
          fs_purchases {
            id
            fs_students {
              FirstName
              LastName
              Email
              id
            }
          }
        }
      }
    }
  }
 `); */



interface EditEventInstructorsProps {
    event: types.Fs_Events;
}

const EditEventInstructors: FC<EditEventInstructorsProps> = ({ event }) => {
    const [isSelectInstructorOpen, setIsSelectInstructorOpen] = useState(false);
    //    const [studentInputValue, setStudentInputValue] = useState('');
    const isSmallScreen = useScreenSize();

    const { data: dataEventInstructors, error: errorEventInstructors, loading: loadingEventInstructors } = useQuery(getInstructorAssignmentQuery, { variables: { id: event.id } });
    const { data: dataGetAllInstructors, error: errorGetAllInstructors, loading: loadingGetAllInstructors } = useQuery(getAllInstructorsQuery);

    const [assignInstructorMutation, { data: dataAssign, loading: loadingAssign, error: errorAssign }] = useMutation(assignInstructorQuery, {
        refetchQueries: [
            'GetInstructorAssignments' // Query name
        ],
    });

    const [deleteAssignmentMutation, { loading: loadingDeleteAssignment, error: errorDeleteAssignment }] = useMutation(deleteInstructorAssignmentQuery, {
        refetchQueries: [
            'GetInstructorAssignments' // Query name
        ],
    });

    const [updateAssignmentMutation, { loading: loadingUpdateAssignment, error: errorUpdateAssignment }] = useMutation(updateInstructorAssignmentQuery, {
        refetchQueries: [
            'GetInstructorAssignments' // Query name
        ],
    });


    const handleDeleteClick = (id) => {
        deleteAssignmentMutation({ variables: { id: id } });
    };

    const handleOnDeckChange = (assignment) => {
        updateAssignmentMutation({ variables: { id: assignment.id, onDeck: !assignment.on_deck } });
    };

    const handleAddAssignment = (instrId, OnDeck) => {
        // TODO: Check for: being signed up
        // TODO!!!: Update cache of purchases for Student Purchases component (or turn cache off)
        const event_id = event.id;
        assignInstructorMutation({ variables: { instrId: instrId, eventId: event_id, onDeck: OnDeck } });
        // TODO: chceck error return and show message
        setIsSelectInstructorOpen(false);
    };



    /*     const handleStudentsInputChange = (e, newInputValue) => {
            if (newInputValue.length >= 3) {
                refetchSelectStudent({st:'%'+newInputValue+'%', cl: event.class });
                setStudentInputValue(newInputValue);
            } else {
                if(studentInputValue !== '') setStudentInputValue('');
            }
        };
     */
    
    //   const searchOptions = (dataSelectStudent?.get_available_regs_for_event.edges && (studentInputValue !== ''))?dataSelectStudent?.get_available_regs_for_event.edges:[];

    return (
      <MDBoxRoot>
          <Card sx={{
            ...(isSmallScreen
            ? { padding: "4px 0px 8px" }
            : { padding: "4px 16px 8px" }), 
            width: '100%'
            }}
            >
            <MDBoxRoot ownerState={{     
                          variant: "contained", 
                          color:"white", 
                          opacity: 1,
                          bgColor: "secondary", 
                          coloredShadow: "secondary" }} 
                      sx={{ display: 'flex',width: '100%' }} 
                      borderRadius={2}
                      pb={1} px={2} mt={-1} >
                    <MDTypographyRoot variant="h3" ownerState={{color:"white"}}>
                      Instructors
                    </MDTypographyRoot>
              </MDBoxRoot>
              <MDBoxRoot
                        px={0} py={2} textAlign="right"
                     >
                    <MDButtonRoot
                        ownerState={{
                            size: "medium",
                            variant: "text",
                            color: "info",
                            textTransform:"uppercase",
                        }}
                        startIcon={<AddIcon />}
                        onClick={() => {setIsSelectInstructorOpen(true);}}>
                    Add Instructor
                    </MDButtonRoot>
                </MDBoxRoot>
                <MDBoxRoot component="table"  sx={{ borderSpacing:"0px"}}>
                        <MDBoxRoot component="thead" ownerState={{     
                                         variant: "contained", 
                                         bgColor: "light"}}
                                         borderRadius={2}>
                            <MDBoxRoot component="tr" >
                                <MDBoxRoot component="td" textAlign="left" px={1} py={1}>
                                    <MDTypographyRoot variant="h5" 
                                                      ownerState={{
                                                            color:"dark",
                                                            fontWeight:"bold"}} >
                                        First Name
                                     </MDTypographyRoot>
                                </MDBoxRoot>
                                <MDBoxRoot component="td" textAlign="left" px={1}>
                                    <MDTypographyRoot variant="h5" 
                                                      ownerState={{
                                                            color:"dark",
                                                            fontWeight:"bold"}} >
                                        Last Name
                                    </MDTypographyRoot>
                                </MDBoxRoot>
                                <MDBoxRoot component="td" textAlign="center" px={1}>
                                    <MDTypographyRoot variant="h5" 
                                                      ownerState={{
                                                            color:"dark",
                                                            fontWeight:"bold"}} >
                                    On Deck
                                    </MDTypographyRoot>
                                </MDBoxRoot>
                                <MDBoxRoot component="td" textAlign="center" px={1}>
                                    <MDTypographyRoot variant="h5" 
                                                      ownerState={{
                                                            color:"dark",
                                                            fontWeight:"bold"}} >
                                        Delete
                                    </MDTypographyRoot>
                                </MDBoxRoot>
                            </MDBoxRoot>
                        </MDBoxRoot>


                        <MDBoxRoot component="tbody">
                            {dataEventInstructors?.fs_instructoreventsCollection.edges?.map((assignment) => (
                              <MDBoxRoot component="tr" key={assignment.node.id} sx={{ '& > *': { borderBottom: 'solid 1px rgba(0, 0, 0, 0.08);' } ,'& > *:hover':{backgroundColor:"black"}}} >
                                    <MDBoxRoot component="td" textAlign="left" px={1}>
                                    <MDTypographyRoot variant="h5" ownerState={{
                                        color:"inherit",
                                        fontWeight:"regular"
                                    }}>
                                        {assignment.node.fs_admins?.first_name}
                                        </MDTypographyRoot>
                                    </MDBoxRoot>
                                    <MDBoxRoot component="td" textAlign="left"px={1}>
                                    <MDTypographyRoot variant="h5" ownerState={{
                                        color:"inherit",
                                        fontWeight:"regular"
                                    }}>
                                      {assignment.node.fs_admins?.last_name}
                                      </MDTypographyRoot>
                                    </MDBoxRoot>
                                    <MDBoxRoot component="td" textAlign="center" px={1}>
                                        <Checkbox defaultChecked={assignment.node.on_deck} onChange={() => handleOnDeckChange(assignment.node)} />
                                    </MDBoxRoot>
                                    <MDBoxRoot component="td" textAlign="center" px={1}>
                                        <MDButtonRoot ownerState={{
                                                    color: "primary",
                                                    iconOnly: true,
                                                    }}  
                                            aria-label="Delete"  onClick={() => { handleDeleteClick(assignment.node.id); }}>
                                            <DeleteIcon />
                                        </MDButtonRoot>
                                    </MDBoxRoot>
                                    </MDBoxRoot>
                            ))}
                        </MDBoxRoot>
                    </MDBoxRoot>

                {/* ================== Select instructor dialog =================== */}
                <AddInstructorDialog
                    isSelectInstructorOpen={isSelectInstructorOpen}
                    setIsSelectInstructorOpen={setIsSelectInstructorOpen}
                    dataGetAllInstructors={dataGetAllInstructors}
                    handleAddAssignment={handleAddAssignment}
                />


            </Card>

        </MDBoxRoot>
    )
}

export default EditEventInstructors;

function AddInstructorDialog(props) {

    const noButtonRef = React.useRef<HTMLButtonElement>(null);
    const [onDeck, setOnDeck] = useState(false);
    const [instructor, setInstructor] = useState(null);

    return (
      <Dialog
      maxWidth="md"
      fullWidth={true}
      open={props.isSelectInstructorOpen}
      onClose={() => props.setIsSelectInstructorOpen(false)}>
     <MDTypographyRoot variant="h5" px={1} py={1}>Adding Instructor
      <CloseIcon onClick={() => props.setIsSelectInstructorOpen(false)}    sx={{position:"absolute", top:"10px", right:"10px"}}/>
          
      </MDTypographyRoot>
      <DialogContent dividers>
          <Autocomplete
              fullWidth={true}
              options={props.dataGetAllInstructors?.fs_adminsCollection.edges}
              onChange={(e, sel) => setInstructor(sel)}
              value={instructor}
              getOptionLabel={(op: any) => {
                  return op?.node.first_name +
                      ' ' + op?.node.last_name
              }}
              renderInput={(params) => (
                <MDInput {...params} label="Search" variant="outlined"/>
              )}
              sx={{
                '& .MuiAutocomplete-listbox': {
                    color:"red",
                    bgcolor: 'background.paper',
                    borderRadius: '8px',
                    boxShadow: 3,
                },
                '& .MuiAutocomplete-option': {
                    color:"red",
                    padding: '8px 16px',
                    '&:hover': {
                        bgcolor: 'primary.light',
                    },
                },
            }}
          />
          <FormControlLabel control={<Checkbox onChange={(e) => setOnDeck(e.target.checked)} />} label="On Deck" />
      </DialogContent>
      <DialogActions>

          <MDButtonRoot 
                        ownerState={{
                          variant: "gradient",
                          color: "dark",
                          textTransform:"none",
                          }}  
                        ref={noButtonRef} 
                        onClick={() => props.setIsSelectInstructorOpen(false)}>
              Close
          </MDButtonRoot>
          <MDButtonRoot 
              ownerState={{
                variant: "gradient",
                color: "info",
                textTransform:"none",
                }} 
              onClick={() => {
              props.handleAddAssignment(instructor?.node.id, onDeck);
              setInstructor(null);
              setOnDeck(false);
          }}>Save</MDButtonRoot>
      </DialogActions>
  </Dialog>);
}
